<template>
  <div class="tabs-view">
    <div class="tabs">
      <div>
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link" :class="{active: isIgActive}" id="igButton" role="tab" @click="selectTab('ig')">
              {{ $t("ig.tab-title") }}
              <span class="badge badge-info badge-pill">{{ nbIncidents }}</span>
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" :class="{active: isWorkplannedActive}" id="workplannedButton" role="tab" @click="selectTab('workplanned')">
              {{ $t("tp.tab-title") }}
              <span class="badge badge-info badge-pill">{{ nbWorkplanned }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="tab-content">
        <incidents-view :incidentsList="incidentsList" class="tab-element" v-if="display === 'ig'"></incidents-view>
        <workplanned-view :workplannedList="workplannedList" class="tab-element" v-else></workplanned-view>
      </div>
    </div>
  </div>
</template>

<script>
import IncidentsView from "./IncidentsView.vue";
import WorkplannedView from "./WorkplannedView.vue";

export default {
  name: "TabsView",
  props: {
    nbIncidents: { type: Number },
    nbWorkplanned: { type: Number },
    incidentsList: { type: Array },
    workplannedList: { type: Array },
  },
  components: {
    IncidentsView,
    WorkplannedView,
  },
  data() {
    return {
      display: 'ig',
      isIgActive: true,
      isWorkplannedActive: false,
    }
  },
  methods: {
    selectTab(tabName) {
      this.display = tabName;
      if (tabName === 'ig') {
        this.isIgActive = true;
        this.isWorkplannedActive = false;
      } else {
        this.isIgActive = false;
        this.isWorkplannedActive = true;
      }
    }
  }
};
</script>

<style>
.badge-info {
  color: #fff;
  background-color: #17a2b8;
}
.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}
.tabs-view {
  margin: .9rem;
}
.tab-element {
  /* border: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; */
}

.tab-content {
  overflow: hidden;
  overflow-y: auto;
}
</style>